import { Injectable } from '@angular/core';
import { PublicClientApplication, AuthenticationResult } from '@azure/msal-browser';
import { AppService } from './app.service';

@Injectable({
  providedIn: 'root',
})
export class MsalAuthService {
  private msalInstance: PublicClientApplication;

  constructor(public appService: AppService) {

    this.appService.getDmsSettingVw().subscribe((dataDMSSetting: any) => {
      let clientId = null;
      let tenantId = "";
      if (dataDMSSetting.tenantId) {
        tenantId = dataDMSSetting.tenantId
      }
      if (dataDMSSetting.clientId) {
        clientId = dataDMSSetting.clientId
      }
      this.msalInstance = new PublicClientApplication({
        auth: {
          clientId: clientId, // Replace with your Azure AD client ID
          authority: 'https://login.microsoftonline.com/' + tenantId, // Replace with your Azure AD tenant ID
          redirectUri: location.origin + '/dashboard/addDocument', // Replace with your app's redirect URI
        },
        cache: {
          cacheLocation: 'localStorage', // Cache in localStorage
          storeAuthStateInCookie: true, // Use cookies for older browsers
        },
      });
      this.initialize();


    });

  }
  private isInitialized = false;
  private async initialize() {
    try {
      await this.msalInstance.initialize();
      this.isInitialized = true; // Mark as initialized
      console.log('MSAL initialized successfully.');
    } catch (error) {
      console.error('MSAL initialization failed:', error);
    }
  }

  // Ensure MSAL is initialized before any call
  private async ensureInitialized() {
    if (!this.isInitialized) {
      console.warn('MSAL is not initialized. Waiting...');
      await new Promise((resolve) => {
        const checkInterval = setInterval(() => {
          if (this.isInitialized) {
            clearInterval(checkInterval);
            resolve(true);
          }
        }, 100); // Check every 100ms
      });
    }
  }

  // Trigger login popup
  async loginPopup(): Promise<AuthenticationResult> {


    try {
      await this.ensureInitialized(); // Ensure MSAL is ready before login
      return this.msalInstance.loginPopup({
        scopes: ['User.Read'],
        prompt: "login"// Adjust scopes as needed
      });
    } catch (error: any) {
      if (error.errorCode === 'user_cancelled' || error.errorCode === 'popup_window_error') {
        console.warn('User closed the popup or cancelled the login:', error.message);
        return error; // Or show a message in UI
      }

      console.error('Login failed:', error);
      throw error; // Propagate if needed
    }
  }

  // Get the current active account
  async getActiveAccount() {
    await this.ensureInitialized(); // Ensure MSAL is ready
    return this.msalInstance.getActiveAccount();
  }

  // Set the active account after login
  async setActiveAccount(account: any) {
    await this.ensureInitialized(); // Ensure MSAL is ready
    this.msalInstance.setActiveAccount(account);
  }

}
